exports = module.exports = require("../../../../../../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".RatingLayer__RatingLayerContainer__2_Hu7 {\n  width: 100%;\n  height: 100%;\n}\n\n.RatingLayer__RatingLayer__27Z1y {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  -webkit-transition: all 0.15s ease-in;\n  -o-transition: all 0.15s ease-in;\n  transition: all 0.15s ease-in;\n}\n", ""]);

// exports
exports.locals = {
	"RatingLayerContainer": "RatingLayer__RatingLayerContainer__2_Hu7",
	"RatingLayer": "RatingLayer__RatingLayer__27Z1y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskPage/WorkspaceView/Structures/TableView/TableCell/RegularCell/RatingLayer/RatingLayer.css
// module id = 817
// module chunks = 0